export const DEFAULT_LOCALE = 'fr-FR' as const;

export const LOCALES = [
    'de-CH',
    'de-DE',
    'en-CA',
    'en-GB',
    'en-US',
    'es-ES',
    'fr-FR',
    'it-IT',
    'nl-NL',
] as const;

export const EVANEOS_LOCALES = [
    'de_CH',
    'de_DE',
    'en_CA',
    'en_GB',
    'en_US',
    'es_ES',
    'fr_FR',
    'it_IT',
    'nl_NL',
] as const;

export const PRISMIC_LOCALES = [
    'nl-nl',
    'en-ca',
    'en-gb',
    'en-us',
    'fr-fr',
    'de-de',
    'de-ch',
    'it-it',
    'es-es',
] as const;
